module.exports = __webpack_public_path__ + "static/linkedlist-2.6-04392d2128c39b361cf2fac43301debd.png";